// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__3ZoTe","label__helper":"style_label__helper__Pa3Io"};